module.exports = __webpack_public_path__ + "img/Wp_2079.1bd05e4e.png";